<div [ngClass]="containerClasses">
  <idp-icon
    [icon]="labelProperties.iconPath || ''"
    class="idp-label__icon"
  ></idp-icon>
  <span [innerHTML]="labelProperties.title" [ngClass]="textClasses"></span>
</div>
